import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum MessageTypeEnum {
  success = 'success',
  warning = 'warning',
  error = 'error',
}

@Injectable({
  providedIn: 'root',
})
export class MessageHelper {
  private okLabel = 'OK';

  constructor(private snackBar: MatSnackBar) {}

  send(message: string, type: MessageTypeEnum = MessageTypeEnum.success) {
    this.snackBar.open(message, this.okLabel, {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: type,
    });
  }
}
